/**
 * InputTextarea Label Wrapper Classes
 */

const inputLabelWrapperClasses = 'flex flex-col gap-1';

/**
 * Site Theme
 */

const inputTextareaSiteTheme = {
  inputLabelWrapperThemeClasses: inputLabelWrapperClasses,
};

export default inputTextareaSiteTheme;
